import _ from 'ckLodash';
import selectionUtils from 'utils/selectionUtils';
import styleCommand from 'commands/styleCommand';
import styleUtils from 'utils/styleUtils';

function EmptySelectionFontSizeCmd() {
    styleCommand.call(this, 'span', 'font-size', {attributes: {class: 'inherit-font-size'}});
}

EmptySelectionFontSizeCmd.prototype = Object.create(styleCommand.prototype);

function FontSizeCmd() {
    styleCommand.call(this, 'span', 'font-size');
}

FontSizeCmd.prototype = Object.create(styleCommand.prototype);

var emptySelectionFontSizeCmd = new EmptySelectionFontSizeCmd();

FontSizeCmd.prototype.exec = function (editor, paramValue) {
    if (selectionUtils.isSelectedTextEmpty(editor)) {
        styleCommand.prototype.exec.call(this, editor, CKEDITOR.TRISTATE_OFF);
        emptySelectionFontSizeCmd.exec(editor, paramValue);
        return;
    }
    styleCommand.prototype.exec.call(this, editor, paramValue);
    var applyStyle = _.partial(styleUtils.applyStyle, paramValue, 'font-size');
    var includePartiallySelectedBlocks = paramValue === CKEDITOR.TRISTATE_OFF;
    selectionUtils.getSelectedBlocks(editor, includePartiallySelectedBlocks).forEach(applyStyle);
    _.forEach(selectionUtils.getSelectedLists(editor), listElement => {
        this.applyOnElement(paramValue, listElement);
    });
};

FontSizeCmd.prototype.applyOnElement = function (value, element) {
    element.setStyle('fontSize', value);
};

export default FontSizeCmd;
